module.exports = __webpack_public_path__ + "static/media/empty-state-list.e710377e.svg";